// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"fc42532e","223":"cb56cb22","299":"7508b579","367":"6ce112dd","661":"daf4f14b","847":"83641d91","999":"7b7918b2"}[chunkId] + ".chunk.js";
};